import { $Q } from "../utils/query-selector"

/**
 * Listen touchstart en touchend events to know in touch device
 * When stop or run animation
 * It is trying to replicate hover or active like CSS
 */

export const brandsTape = () => {
  const tape = $Q('.marquee')

  if (!tape) return;

  window.addEventListener('touchstart', (e) => {
    if (e.target.classList.contains('marquee')) {
      !tape.classList.contains('touch') && tape.classList.add('touch')
    } else {
      tape.classList.contains('touch') && tape.classList.remove('touch')
    }
  }, { passive: true });

  window.addEventListener('touchend', () => {
    tape.classList.contains('touch') && tape.classList.remove('touch')
  }, { passive: true })
}
